import { SDK_SET_BUBBLE_VISIBILITY } from "shared/constants/sharedFrameEvents";

import { IFrameHelper } from "./IFrameHelper";
import { getDarkMode, getWidgetStyle } from "./settingsHelper";
import { getAuthTokenCookieName, hasUserKeys } from "../shared/helpers/cookieHelpers";
import { addClasses, removeClasses } from "./DOMHelpers";

function main({ baseUrl, widgetId } = {}) {
  const unthreadSettings = window.$unthreadInAppChatSettings || window.$unthreadSettings || {};

  const state = {
    baseUrl: baseUrl ?? unthreadSettings.baseUrl,
    widgetId: widgetId ?? unthreadSettings.widgetId,
    hasLoaded: false,
    isOpen: false,
    resetTriggered: false,
    hideBubble: unthreadSettings.hideBubble || false,
    messageBubbleHidden: true,
    position: unthreadSettings.position === "left" ? "left" : "right",
    launcherTitle: unthreadSettings.launcherTitle || "",
    showPopoutButton: unthreadSettings.showPopoutButton || false,
    widgetStyle: getWidgetStyle(unthreadSettings.widgetStyle) || "standard",
    darkMode: getDarkMode(unthreadSettings.darkMode),
  };

  if (!state.baseUrl || !state.widgetId) {
    console.warn("Could not initialize Unthread widget. Missing widgetId or baseUrl.");
    return;
  }

  const toggle = (type) => {
    IFrameHelper.events.toggleBubble(state, type);
  };

  const toggleBubble = (visibility) => {
    let widgetElm = document.querySelector(".unthread--bubble-holder");
    let widgetHolder = document.querySelector(".unthread-widget-holder");

    if (visibility === "hide") {
      addClasses(widgetHolder, "unthread-widget--without-bubble");
      addClasses(widgetElm, "unthread-hidden");

      state.messageBubbleHidden = true;
    } else if (visibility === "show") {
      removeClasses(widgetElm, "unthread-hidden");
      removeClasses(widgetHolder, "unthread-widget--without-bubble");

      state.messageBubbleHidden = false;
    }

    IFrameHelper.sendMessage(SDK_SET_BUBBLE_VISIBILITY, {
      messageBubbleHidden: state.messageBubbleHidden,
    });
  };

  const setLocale = (localeToBeUsed = "en") => {
    IFrameHelper.sendMessage("set-locale", { locale: localeToBeUsed });
  };

  const start = ({ user } = {}) => {
    if (user) {
      if (!hasUserKeys(user)) {
        throw new Error("User object should have one of the keys [imageUrl, email, name]");
      }
    }

    IFrameHelper.sendMessage("start", { user, authToken: localStorage.getItem(getAuthTokenCookieName(state)) });
  };

  const stop = () => {
    if (state.isOpen) {
      IFrameHelper.events.toggleBubble(state);
    }

    toggleBubble("hide");

    IFrameHelper.sendMessage("stop");

    localStorage.removeItem(getAuthTokenCookieName(state));

    const iframe = IFrameHelper.getAppFrame();

    if (iframe) {
      iframe.src = IFrameHelper.getUrl({
        baseUrl: state.baseUrl,
        widgetId: state.widgetId,
      });
    }

    state.resetTriggered = true;
  };

  const setDarkMode = (darkMode) => {
    IFrameHelper.sendMessage("set-dark-mode", { darkMode });
  };

  const sdk = {
    toggle,
    toggleBubble,
    setLocale,
    start,
    stop,
    setDarkMode,
  };

  state.onReady = () => {
    const initialCalls = window.$unthread?.inAppChat?.q ?? window.$unthread?.q ?? [];

    const call = (args) => {
      const argsArray = Array.from(args);
      const func = argsArray[0];
      const params = argsArray[1];

      if (typeof sdk[func] === "function") {
        sdk[func](params);
      }
    };

    if (!window.$unthread) {
      window.$unthread = {};
    } else if (typeof window.$unthread === "function") {
      const helpCenter = window.$unthread.helpCenter;

      window.$unthread = function () {
        call(arguments);
      };
      window.$unthread.helpCenter = helpCenter;
    }

    window.$unthread.inAppChat = function () {
      call(arguments);
    };

    for (const c of initialCalls) {
      call(c);
    }
  };

  IFrameHelper.createFrame(state);
}

if (window.$unthread?.inAppChat || typeof window.$unthread === "function") {
  main();
} else {
  window.unthreadSdk = {
    run: main,
  };
}
